



















import { Component, Prop, Vue } from 'vue-property-decorator'
import { chain, map, sortBy } from 'lodash'
import { Circuit, RoutineCircuit, VuetifySelectItem } from '@/interfaces'
import { emptyArray } from '@/utils'

@Component({
  components: {}
})
export default class RoutineCircuitList extends Vue {
  @Prop({ default: emptyArray }) routineCircuits!: RoutineCircuit[]

  get circuitItems (): VuetifySelectItem[] {
    const items = map(this.$store.getters['circuits/all'], (circuit: Circuit) => {
      return {
        text: circuit.name.en,
        value: circuit.id
      }
    })

    return sortBy(items, 'text')
  }

  addCircuit () {
    this.routineCircuits.push({
      circuitId: ''
    })

    console.log(this.routineCircuits)
  }

  removeCircuit (index: number) {
    Vue.delete(this.routineCircuits, index)
  }
}
